import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 获取人员列表
  userList(data) {
    const params = data
    return request({
      url: urlParams + '/user/list',
      type: 'get',
      params: params
    })
  },  
  // 人员新增修改
  userUpdata(data) {
    const params = data
    return request({
      url: urlParams + '/user/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },   
    // 修改状态
  userUpdateStatus(data) {
    const params = data
    return request({
      url: urlParams + '/user/updateStatus',
      type: 'post',
      params: params
    })
  },  
  // 删除
  userDel(data) {
    const params = data
    return request({
      url: urlParams + '/user/del',
      type: 'post',
      params: params
    })
  },   
  // 物业人员列表
  manageUserList(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user/list',
      type: 'get',
      params: params
    })
  },  
  // 物业人员新增修改
  manageUserAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },
  // 物业人员修改密码
  updatePassword(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user/updatePassword',
      type: 'post',
      params: params
    })
  },   
  // 物业人员删除
  manageUserDel(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user/delete',
      type: 'post',
      params: params
    })
  },    
  // 物业人员重置密码
  manageUserResetPassWord(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user/resetPassWord',
      type: 'post',
      params: params
    })
  },  
  // 物业人员绑定楼栋列表
  manageRidgepole(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user/manageRidgepole',
      type: 'get',
      params: params
    })
  },   
  // 物业人员添加楼栋
  saveManageRidgepole(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user/saveManageRidgepole',
      type: 'post',
      params: params,
      qs:false
    })
  },   
  // 物业人员删除楼栋
  deleteManageRidgepole(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user/deleteManageRidgepole',
      type: 'post',
      params: params
    })
  },  
  // 物业人员总列表
  manageTotalList(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user/totalList',
      type: 'get',
      params: params
    })
  },  
  // 车辆信息列表
  vehicleList(data) {
    const params = data
    return request({
      url: urlParams + '/user-vehicle/list',
      type: 'get',
      params: params
    })
  },  
  // 车辆信息列表
  vehicleAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/user-vehicle/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // 车辆信息列表
  vehicleDel(data) {
    const params = data
    return request({
      url: urlParams + '/user-vehicle/del',
      type: 'post',
      params: params
    })
  },  
  // 车辆信息导入
  vehicleImportCreateVehicle(data) {
    const params = data
    return request({
      url: urlParams + '/user-vehicle/importCreateVehicle',
      type: 'post',
      params: params,
      qs:false
    })
  }, 
  // 物业人员分类总列表
  manageTypeAllList(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user-type/totalList',
      type: 'get',
      params: params
    })
  }, 
  // 物业人员分类列表
  manageTypeList(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user-type/list',
      type: 'get',
      params: params
    })
  },
  // 物业人员分类添加
  manageTypeAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user-type/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  }, 
  // 物业人员分类删除
  manageTypeDel(data) {
    const params = data
    return request({
      url: urlParams + '/manage-user-type/del',
      type: 'post',
      params: params
    })
  },  
  // 用户审核列表
  userRegisterList(data) {
    const params = data
    return request({
      url: urlParams + '/user-register/list',
      type: 'get',
      params: params
    })
  },  
  
  userRegisterDetail(data) {
    const params = data
    return request({
      url: urlParams + '/user-register/detail',
      type: 'get',
      params: params
    })
  },

  // 用户审核列表审核
  userRegisterVerify(data) {
    const params = data
    return request({
      url: urlParams + '/user-register/verify',
      type: 'post',
      params: params
    })
  },                            
}